import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import AnchorLink from 'components/AnchorLink';
import styles from 'components/NextOrder/NextOrder.scss';
import PendingOrderSummaryV1 from 'components/PendingOrders/PendingOrderSummaryV1';
import urls from 'constants/urls';
import { useWtrSelector } from 'redux/hooks';
import { isWismoEnabled } from 'redux/modules/order/selectors/isWismoEnabled';
import OrderCard from '../PendingOrders/OrderCard/OrderCard';

const NextOrder = ({
  analyticsTags,
  breakpointClasses,
  hidden = false,
  pendingOrderId = null,
  isLoaded = false,
}) => {
  const checkoutWismoEnabled = useWtrSelector(isWismoEnabled);

  return isLoaded && pendingOrderId && !hidden ? (
    <article
      className={classNames(breakpointClasses, styles.nextOrder)}
      data-test="next-order"
      {...analyticsTags}
    >
      <h2 className={styles.heading}>Your next order</h2>
      {checkoutWismoEnabled ? (
        <OrderCard orderId={pendingOrderId} />
      ) : (
        <PendingOrderSummaryV1 orderId={pendingOrderId} />
      )}
      <AnchorLink className={styles.viewAll} to={urls.myOrdersPage}>
        View all orders
      </AnchorLink>
    </article>
  ) : null;
};

NextOrder.displayName = 'NextOrder';

NextOrder.propTypes = {
  analyticsTags: PropTypes.shape({}),
  breakpointClasses: PropTypes.arrayOf(PropTypes.string),
  hidden: PropTypes.bool,
  pendingOrderId: PropTypes.string,
  isLoaded: PropTypes.bool,
};

export default NextOrder;
